/**
 * IDs de módulos del catálogo admin (server_admin/src/companies/constants/available-modules.ts).
 * Mantener alineado con AVAILABLE_MODULES / Nest `AVAILABLE_MODULES`.
 */
export const ALL_KNOWN_MODULE_IDS = [
  'dashboard',
  'softlanding',
  'reportes_ventas',
  'reportes_compras',
  'reportes_cobranza',
  'reportes_proveedores',
  'reportes_dj',
  'reportes_rrhh',
  'reportes_personalizados',
  'flujo_caja',
  'eerr',
  'eoaf',
  'creditos',
  'documentos_tributarios',
  'boletas',
  'obligaciones',
  'cuotas_creditos',
  'din',
  'conciliacion',
  'cobranza',
  'pago_proveedores',
  'cuadre_cartolas',
  'tarjetas_credito',
  'formulario_29',
  'consolidado_f29',
  'multas_sii',
  'cuadre_formulario_29',
  'balance_8_columnas',
  'balance_clasificado',
  'eerr_contable',
  'libro_mayor',
  'libro_diario',
  'asientos',
  'plan_cuentas',
  'estructuras_maestras',
  'estado_de_resultados_gestion',
  'balance_clasificado_gestion',
  'centralizacion_contable',
  'libro_compra_venta',
  'cierre_apertura_contable',
  'avance_contable',
  'haberes_variables',
  'cargar_nuevo_empleado',
  'contratos_proximos_a_vencer',
  'validador_liquidaciones',
  'repositorio_informacion_inicial',
  'repositorio_informes_financieros',
  'repositorio_presupuestos',
  'repositorio_certificados',
  'repositorio_formularios',
  'repositorio_libro_remuneraciones',
  'repositorio_haberes_variables',
  'repositorio_directorio',
  'repositorio_auditorias',
  'repositorio_cartola_diaria',
  'repositorio_proveedores_hoja',
  'repositorio_flujo_caja_mensual',
  'repositorio_flujo_caja_quincenal',
  'repositorio_flujo_caja_semanal',
  'conexiones',
  'agenda',
  'configuracion',
  'ficha_cliente',
  'configuracion_equipo',
  'configuracion_api_key',
  'configuracion_automatizaciones',
  'descargas',
]
